import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function IconSparkle(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 21 20"
            width="24px"
            fill="currentColor"
            data-testid="IconSparkle"
            {...props}
        >
            <path d="M19.2901 9.09458C15.1959 7.3545 13.2569 5.49228 11.521 1.47437C10.8617 -0.158729 10.3064 -0.705936 9.51492 1.24432C7.78372 5.3995 5.71723 7.38006 1.64847 9.09458C1.23952 9.28298 0.504722 9.61149 0.5 9.99965C0.504722 10.3888 1.23574 10.7163 1.64847 10.9047C5.7125 12.6145 7.78372 14.5998 9.51492 18.755C10.3158 20.7403 10.8731 20.1164 11.521 18.5249C13.2569 14.5089 15.1959 12.6458 19.2901 10.9047C19.7189 10.7002 20.4282 10.4285 20.5 10.0205V9.97409C20.4282 9.56983 19.7246 9.29434 19.2901 9.08984V9.09458Z" />
        </svg>
    );
}
